import { render, staticRenderFns } from "./StatusValueCardForm.vue?vue&type=template&id=bf8cc492"
import script from "./StatusValueCardForm.vue?vue&type=script&lang=js"
export * from "./StatusValueCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports